export class UrlBuilder {
    private rootUrl: string;
    private paths: string[] = [];
    private queryParams: Record<string, string | number | boolean> = {};
  
    constructor(rootUrl: string) {
      this.rootUrl = rootUrl.replace(/\/$/, ''); // Ensure no trailing slash
    }
  
    addPath(...segments: string[]): this {
      this.paths.push(...segments.map(segment => segment.replace(/^\/|\/$/g, ''))); // Trim slashes
      return this;
    }
  
    setQueryParam(key: string, value: string | number | boolean | undefined): this {
      if (value !== undefined) {
        this.queryParams[key] = value;
      }
      return this;
    }
  
    removeQueryParam(key: string): this {
      delete this.queryParams[key];
      return this;
    }
  
    toString(): string {
      const path = this.paths.length > 0 ? '/' + this.paths.join('/') : '';
      const queryString = Object.entries(this.queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
  
      return `${this.rootUrl}${path}${queryString ? '?' + queryString : ''}`;
    }
  }
  